<div class="form-group" [style.width]="config.width || '100%'">
  <div class="position-relative" [class.typeahead-with-caret]="showDropdownCaret">
    <input
      #typeaheadInput
      class="form-control"
      [class.typeahead-input-caret]="showDropdownCaret"
      [class.is-invalid]="!getIsLoading() && isInvalid()"
      type="text"
      [attr.id]="inputId ?? null"
      [attr.name]="inputName ?? inputId ?? null"
      [attr.title]="selectedValue || null"
      [autocomplete]="autocomplete"
      [placeholder]="config.placeholder || 'Search...'"
      [disabled]="getIsLoading()"
      [ngbTypeahead]="searchFunction"
      (focus)="onFocus($event)"
      (click)="onClick($event)"
      (blur)="onBlur($event)"
      (selectItem)="onItemSelect($event.item)"
      [editable]="false"
      [required]="config.required || false"
      [(ngModel)]="selectedValue"
      (ngModelChange)="onSelectionChange($event)"
      [class.pe-4]="config.clearable && selectedItem"
      #instance="ngbTypeahead">

    @if (config.clearable && selectedItem) {
      <button
        type="button"
        class="typeahead-clear"
        aria-label="Clear"
        (mousedown)="$event.preventDefault()"
        (click)="clearSelection($event)"
      >
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    }

    @if (getIsLoading()) {
      <div class="typeahead-loading-overlay d-flex align-items-center" aria-hidden="true">
        <div class="spinner-border spinner-border-sm me-2" role="presentation"></div>
        <span class="text-muted">Loading...</span>
      </div>
    }
  </div>
  @if (!getIsLoading() && isInvalid()) {
    <div class="invalid-feedback d-block">
      {{ getValidationMessage() }}
    </div>
  }
</div>
